export const processBrowserNavigator = (navigatorGranted, navigatorBlocked, shouldShowBrowserGeoPopup, isWatch) => {
  if (!navigator.geolocation) {
    navigatorBlocked()
  }

  const options = { timeout: 500, maximumAge: 300000, enableHighAccuracy: true }
  if (shouldShowBrowserGeoPopup) {
    navigator.geolocation.getCurrentPosition((coords) => navigatorGranted(coords), () => navigatorBlocked(), options)
  } else {
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' })
        .then(response => {
          if (response.state === 'granted') {
            navigator.geolocation.getCurrentPosition((coords) => navigatorGranted(coords), () => navigatorBlocked(), options)
          } else navigatorBlocked()
        })
    } else {
      if (!localStorage.getItem('selectedUserLocation')) {
        navigatorBlocked()
      }
      navigator.geolocation.getCurrentPosition((coords) => navigatorGranted(coords), () => navigatorBlocked(), options)
    }
  }

  if (isWatch) {
    const watcher = navigator.geolocation.watchPosition((coords) => {
      navigatorGranted(coords)
    }, () => {}, options)

    setTimeout(() => {
      navigator.geolocation.clearWatch(watcher)
    }, 20000)
  }
}
